module.exports = __webpack_public_path__ + "static/media/Menu.c65b5f6a.svg";